var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dynamicComponent && _vm.notificationData)?_c(_vm.dynamicComponent,_vm._b({tag:"component"},'component',_vm.notificationData,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }